import { put, takeLatest } from "@redux-saga/core/effects";
import AxiosCustom from "../../../components/common/apiConfig";
import { handleNotificationAlertCatch } from "../../../components/method/handleNotificationAlert";

  
  
  export const actionTypes = {
      selectCommoditiesBourse:"[selectCommoditiesBourse] Action",
      selectCommoditiesBourseAsync:"[selectCommoditiesBourseAsync] Action",
      selectCommoditiesBourseLoading:"[selectCommoditiesBourseLoading] Action"
  }

  const initialState={
      data:[],
      size:20,
      total:10000,
      loading:false
  }


  export const select_commodities_reducer = (state=initialState,{type,payload})=>{
    switch (type) {
        case actionTypes.selectCommoditiesBourse:

          let data = payload?.results.map((keyItem)=>{
            let id =    Object.keys(keyItem)?.[0]
            return{
              id:id,
              data:keyItem[id]
            }
          })
          
          return {
            ...state,
            data: data,
            total:data?.length? data?.length : 0
          };

          case actionTypes.selectCommoditiesBourseLoading:
            return {
              ...state,
              loading:payload
            };
        default:
          return state;
      }
  }



  function* handleWorker({ payload }) {

    let config = {
      url: "select_request"
    };
  
    let data = {
      table: "imetrade",
      method_type: "select_commodities",
      from: payload?.from ? (payload.from - 1) * payload.size : 0,
      size: payload?.size,
      data: payload?.data ? payload.data : {},
      sort_by: payload?.sort_by ? payload?.sort_by :{} ,
    };
  
    try {
      
      yield put({type:actionTypes.selectCommoditiesBourseLoading,payload:true})

      let res = yield AxiosCustom(config, data);  

    //   let flag = handleNotificationAlertTrySelect(res);
      
    //   if (!flag) return;
      
      yield put({
        type: actionTypes.selectCommoditiesBourse,
        payload: res.data.response.data
      });
      
    } catch {
      handleNotificationAlertCatch();
    }
    finally{
      yield put({type:actionTypes.selectCommoditiesBourseLoading,payload:false})
    }
  }
  
  export function* bourseSelectCommoditiesWorker() {
    yield takeLatest(actionTypes.selectCommoditiesBourseAsync, handleWorker);
  }
  